import KeyValuePair from '@/modules/core/support/KeyValuePair'

/**
 * Tipo de evento de calendario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class CalendarEventType {
    public key = ''
    public name = ''
    public nonworking = false

    /**
     * Constructor
     *
     * @param id
     */
    constructor (public readonly id = 0) {}

    /**
     * Indica si la entidad es nueva y todavía no ha sido registrada en el servidor
     */
    public get isNew () {
        return !this.id
    }

    /**
     * Crea un entidad en base a la información en plano serializada
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const type = new this(data.id)
        type.key = data.key
        type.name = data.name
        type.nonworking = data.nonworking

        return type
    }

    /**
     * Convierte la entidad en un objeto plano para ser enviado a la API
     */
    public serialize () {
        return {
            key: this.key,
            name: this.name,
            nonworking: this.nonworking,
        }
    }
}
